import React from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, HeartCrack, CloudFog } from 'lucide-react';
export function TheProblem() {
  const problems = [{
    icon: <BatteryWarning className="w-8 h-8 text-amber" data-id="element-102" />,
    text: 'Tu paciencia se está agotando.'
  }, {
    icon: <HeartCrack className="w-8 h-8 text-amber" data-id="element-103" />,
    text: 'Tu relación de pareja está bajo presión.'
  }, {
    icon: <CloudFog className="w-8 h-8 text-amber" data-id="element-104" />,
    text: "Esa 'niebla mental' te impide disfrutar de la maternidad."
  }];
  return <section className="py-24 bg-white relative" data-id="element-105">
      <div className="max-w-4xl mx-auto px-6" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-107">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6" data-id="element-108">
            Has intentado todo
          </h2>
          <p className="text-lg text-navy/70 leading-relaxed max-w-2xl mx-auto" data-id="element-109">
            Mecerlo hasta que se te duermen los brazos, paseos en coche a
            medianoche, o esperar a que se duerma por puro agotamiento. Pero
            nada funciona a largo plazo.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-110">
          {problems.map((prob, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-cream p-8 rounded-2xl text-center shadow-sm border border-navy/5" data-id="element-111">
              <div className="mx-auto w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-112">
                {prob.icon}
              </div>
              <p className="text-navy font-medium text-lg" data-id="element-113">{prob.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center bg-rose/10 p-8 rounded-2xl" data-id="element-114">
          <p className="text-lg text-navy/80 italic" data-id="element-115">
            Sientes que la única opción es el polémico "dejarlo llorar" hasta
            que se rinda, pero tu instinto te dice que tiene que haber otra
            manera.
          </p>
        </motion.div>
      </div>
    </section>;
}